import React from "react";
import { useNavigate } from "react-router-dom";
import { useGetUsersQuery } from "../../redux/api/usersApi";
import { 
  Table, 
  Button, 
  Typography, 
  Alert, 
  Space, 
  Tag
} from "antd";
import { EditOutlined, PlusOutlined, UserOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const UsersPage = () => {
  const navigate = useNavigate();
  const { data: users = [], isLoading, error } = useGetUsersQuery();

  // Table columns configuration
  const columns = [
    {
      title: 'ID',
      dataIndex: 'user_id',
      key: 'user_id',
      width: '10%',
    },
    {
      title: 'Name',
      key: 'name',
      width: '25%',
      render: (_, record) => (
        <Space>
          <UserOutlined />
          <Text strong>{record.first_name} {record.last_name}</Text>
        </Space>
      ),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: '30%',
    },
    {
      title: 'Roles',
      dataIndex: 'roles',
      key: 'roles',
      width: '25%',
      render: (roles) => (
        roles ? (
          <Tag color="blue">{roles}</Tag>
        ) : (
          <Text type="secondary">No roles</Text>
        )
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      width: '10%',
      render: (_, record) => (
        <Button
          type="link"
          icon={<EditOutlined />}
          onClick={() => navigate(`/admin/users/${record.user_id}/edit`)}
          title="Edit"
        >
          Edit
        </Button>
      ),
    },
  ];

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
        <Alert title="Loading users..." type="info" />
      </div>
    );
  }

  if (error) {
    return (
      <Alert
        message="Error loading users"
        description={error?.data?.message || error?.error || 'Failed to load users'}
        type="error"
        showIcon
      />
    );
  }

  return (
    <div>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <Title level={1} style={{ margin: 0 }}>Users</Title>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => navigate("/admin/users/add")}
        >
          Add User
        </Button>
      </div>

      {users.length === 0 ? (
        <Alert
          message="No users found"
          description="No users available."
          type="info"
          showIcon
        />
      ) : (
        <Table
          columns={columns}
          dataSource={users}
          rowKey="user_id"
          pagination={false}
          size="middle"
        />
      )}
    </div>
  );
};

export default UsersPage;
